/* eslint-disable no-restricted-imports */

import { useCallback } from 'react';

import { useMutation } from '@apollo/client';
import {
  ClientAcceptAgreementsDocument,
  ClientRepresentativeAcceptAgreementsDocument,
  LegalClientBeneficiaryAcceptAgreementsDocument,
  LegalClientHeadAcceptAgreementsDocument,
  LegalClientLegalHeadFirstHeadAcceptAgreementsDocument,
  LegalClientRepresentativeAcceptAgreementsDocument,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { ClientIdentityType } from 'api/types/data';
import { useServerErrorNotify } from 'hooks';
import { useUser } from 'libs/providers';

export const useAcceptClientAgreements = () => {
  const { client } = useUser();

  let doc;

  switch (client?.type) {
    case ClientIdentityType.Client:
    case ClientIdentityType.ClientWithRepresentative:
      doc = ClientAcceptAgreementsDocument;
      break;
    case ClientIdentityType.ClientRepresentative:
      doc = ClientRepresentativeAcceptAgreementsDocument;
      break;
    case ClientIdentityType.LegalClientBeneficiary:
      doc = LegalClientBeneficiaryAcceptAgreementsDocument;
      break;
    case ClientIdentityType.LegalClientHead:
      doc = LegalClientHeadAcceptAgreementsDocument;
      break;
    case ClientIdentityType.LegalClientLegalHeadFirstHead:
      doc = LegalClientLegalHeadFirstHeadAcceptAgreementsDocument;
      break;
    case ClientIdentityType.LegalClientRepresentative:
      doc = LegalClientRepresentativeAcceptAgreementsDocument;
      break;
    default:
      throw new Error('client not found');
  }

  const [acceptClientAgreements, { loading, error: apolloError }] = useMutation<
    { accept: boolean },
    { id: string; input: { agreementIds: string[] } }
  >(doc);

  const error = useError(apolloError);

  const handleAcceptClientAgreements = useCallback(
    async (agreementIds: string[]) => {
      const res = await acceptClientAgreements({
        variables: {
          id: client.id,
          input: { agreementIds },
        },
      });

      return res.data?.accept;
    },
    [acceptClientAgreements, client.id]
  );

  useServerErrorNotify(error);

  return {
    acceptClientAgreements: handleAcceptClientAgreements,
    loading,
  };
};
